export const COLUMN_DEFAULTS = {
  padding: '20px 0px 20px 0px', // top right bottom left
  paddingRoot: '20px 30px 20px 30px',
  paddingMobile: '0px 0px 0px 0px',
  paddingRootMobile: '0px 0px 0px 0px',
  margin: '0px 0px 0px 0px',
  gap: '30px',
  gapMobile: '16px',
  gapMobileVertical: '10px',
  borderRadius: '0px 0px 0px 0px',
  boxShadow: 'none',
};
